import { useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';

const siteKey = '6LesGEgqAAAAAHnTDByaURNTt9m0-k6E9ikIqj45';

const useRecaptcha = (ref) => {
  const getToken = useCallback(
    (callback) =>
      window.grecaptcha.ready(() =>
        window.grecaptcha.execute(siteKey, { action: 'submit' }).then(callback),
      ),
    [],
  );

  useEffect(() => {
    if (ref.current) {
      const script = document.createElement('script');
      ref.current.setAttribute('data-sitekey', siteKey);
      script.src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`;
      document.body.appendChild(script);

      return () => script.remove();
    }
  }, [ref]);

  return getToken;
};

useRecaptcha.propTypes = {
  ref: PropTypes.object,
};

export default useRecaptcha;
